import { RegiaoRepresentante } from '../regiao-representante';

export class RegiaoRepresentantePopula {
    selected: boolean;
    exist: boolean;
    regiaoRepresentante: RegiaoRepresentante;
}
